import { render, staticRenderFns } from "./collection-template.vue?vue&type=template&id=826f5eb6&"
import script from "./collection-template.vue?vue&type=script&lang=js&"
export * from "./collection-template.vue?vue&type=script&lang=js&"
import style0 from "./collection-template.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports